import { render, staticRenderFns } from "./DiscoverServiceProviders.vue?vue&type=template&id=4657d248&"
import script from "./DiscoverServiceProviders.vue?vue&type=script&lang=js&"
export * from "./DiscoverServiceProviders.vue?vue&type=script&lang=js&"
import style0 from "./DiscoverServiceProviders.vue?vue&type=style&index=0&id=4657d248&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports